

const BenefitsData = {
    Benefits: [
        {
            id: '1',
            HRtitles : 'Reduced Reputational Risk',
            HRdescription: 'A single recall can do long-term damage to your company\'s reputation. Minimize risk by analyzing every single load..',
            Hicon: 'shield',
            rclass : 'pr_70',
            iclass: 'icon_six',
        },
        {
            id: '2',
            HRtitles : 'Reduced Load Loss',
            HRdescription: 'Eliminate lost loads from your business by using our advanced analysis to highlight where problems are occuring and what to do about it.',
            Hicon: 'stats-down',
            rclass : 'pl_50 pr_20',
            iclass: 'icon_two',
        },
        {
            id: '3',
            HRtitles : 'Reduced Insurance',
            HRdescription: 'Reduce insurance premiums by demonstrating to your insurer how every single load is analyzed to prevent any safety issues from occurring.',
            Hicon: 'files',
            rclass : 'pl_70',
            iclass: 'icon_three',
        },
        /*{
            id: '4',
            HRtitles : 'Supply Chain Optimisation',
            HRdescription: 'An estimated 30% of food produced does not make it to the table. An estimated 25% of Pharma shipments experience temperature excursions in transit. Improve your supply chain to eliminate waste by analyzing every step of the cold chain.',
            Hicon: 'thumb-up',
            rclass : 'pr_70',
            iclass: 'icon_five',
        },*/
        {
            id: '5',
            HRtitles : 'Improved Food Safety',
            HRdescription: 'Our detailed analysis provides insights into issues that may affect product quality and food safety, allowing you to act to prevent a food safety issue before it occurs.',
            Hicon: 'truck',
            rclass : 'pl_50 pr_20',
            iclass: 'icon_four',
        },
        {
            id: '6',
            HRtitles : 'Reduced Risk',
            HRdescription: 'We analyze data for over 10 different risk categories that can affect product quality and safety. And we can do this for every single load you ship.',
            Hicon: 'bolt',
            rclass : 'pl_70',
            iclass: 'icon_five',
        },
        {
            id: '7',
            HRtitles : 'Improved ROI',
            HRdescription: 'Improve the ROI on your telematics system by using data you already have to improve your supply chain operations. Leverage the real-world data in your telematics system to produce real-world savings.',
            Hicon: 'bar-chart',
            rclass : 'pl_70',
            iclass: 'icon_one',
        }
    ],
}
export default BenefitsData;